import moment from 'moment';
export default (params) => ({
  ...params,
  completed_payments_before: moment()
    .endOf('year')
    .toDate()
    .toISOString(),
  completed_payments_after: moment()
    .startOf('year')
    .toDate()
    .toISOString(),
  outstanding_payments_before: moment()
    .endOf('year')
    .toDate()
    .toISOString(),
  outstanding_payments_after: moment()
    .startOf('year')
    .toDate()
    .toISOString(),
  refunds_before: moment()
    .endOf('year')
    .toDate()
    .toISOString(),
  refunds_after: moment()
    .startOf('year')
    .toDate()
    .toISOString()
});



// WEBPACK FOOTER //
// ./webpack/routes/params/PaymentsGraphParams.js